import React from 'react';

type Props = {
  onChange: (value: number) => void;
  disabled?: boolean;
  percent: number; // 0-100
};

const PercentageBtn: React.FC<Props> = (props) => {
  const pctLabel = props.percent === 100 ? 'Max' : `${props.percent}%`;
  const btnStyle = 'rounded-full py-1 px-[10px] ml-3 font-semibold text-sm';
  const btnClassName = props.disabled ? 'secondary-button-disabled ' : 'secondary-button ';
  return (
    <button
      className={btnClassName + btnStyle}
      onClick={() => props.onChange(props.percent)}
      disabled={props.disabled}
    >
      {pctLabel}
    </button>
  );
};

export default PercentageBtn;
